import replaceAt from "./replaceAt";

export default function parseDate(date) {
  if(!date) return

  if(typeof date === "string" && date.length === 19) {
    date = replaceAt(date, 10, 'T')
  }

  return new Date(date)
}
